import { render } from "./BatchDashboard.vue?vue&type=template&id=7b35b834&scoped=true&ts=true"
import script from "./BatchDashboard.vue?vue&type=script&lang=ts"
export * from "./BatchDashboard.vue?vue&type=script&lang=ts"

import "./BatchDashboard.vue?vue&type=style&index=0&id=7b35b834&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b35b834"],['__file',"src/views/BatchDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b35b834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b35b834', __exports__)) {
    api.reload('7b35b834', __exports__)
  }
  
  module.hot.accept("./BatchDashboard.vue?vue&type=template&id=7b35b834&scoped=true&ts=true", () => {
    api.rerender('7b35b834', render)
  })

}


export default __exports__